export default "__VITE_ASSET__D$aWKCzq__"